export default "<img matListAvatar src=\"{{user?.photoURL}}\" alt=\"...\">\n<p class=\"wrap\" mat-line>\n  {{user?.name}}\n</p>\n"